<template>
    <div class="body_main">
        <div class="body_bd" ref="multipleOrderTable">
            <div class="width100 flex_c_between">
                <!-- 搜索-->
                <el-form class="search_con flex_c_left mrt16" :model="treatOrderParams" ref="queryForm" :inline="true"
                         label-width="80px">
                    <el-form-item label="诊疗项目">
                        <el-select class="treat_select_style" v-model="treatOrderParams.projectType" placeholder="诊疗项目">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="检查" value="0"></el-option>
                            <el-option label="治疗" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="诊疗单状态">
                        <el-select style="width: 120px" v-model="treatOrderParams.orderStatus" placeholder="诊疗单状态">
                            <el-option label="待支付" value="1"></el-option>
                            <el-option label="已支付" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="患者姓名">
                        <div class="width100 posi_rela">
                            <el-input v-model="treatOrderParams.dppName" placeholder="姓名(必填)" clearable @input="queryPatiantListByName"></el-input>
                            <div class="name_select_con" v-if="nameSelectConShow">
                                <div :class="item.isChoose ? 'name_select_li name_select_li_act flex_c_between':'name_select_li flex_c_between'"
                                     v-for="(item, index) in patientRange" :key="index" @click="sureChoosePatient(item.dppId, item.name)">
                                    <div style="float: left">
                                        <span class="font_w" >{{ item.name }}</span>
                                        <span class="mrl10" style="color: var(--el-text-color-secondary); font-size: 13px;">
                                            <span>{{ item.sex }}</span>
                                            <span class="mrl10">{{ item.age }}岁</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="诊断结果">
                        <el-input
                            v-model="treatOrderParams.diagnosis"
                            placeholder="诊断关键字"
                            clearable
                        />
                    </el-form-item>
                    <el-form-item label="开单日期">
                        <el-date-picker
                            v-model="dateTime"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="chooseDateTime($event)"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="mrl20" plain type="primary" icon="Search" @click="getTreatHistoryOrderList">搜索</el-button>
                        <el-button class="mrl20" plain type="info" icon="RefreshLeft" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
<!--                <el-button class="mrl20" type="warning" icon="Plus" @click="openAddTreat">开单</el-button>-->
            </div>

            <!-- 表格-->
            <div class="table_bd">
                <div class="thead_div">
                    <div class="thead_bd_div flex_c_left">
                        <el-col class="table_td flex_c" :span="1">序号</el-col>
                        <el-col class="table_td" :span="3">订单编号</el-col>
                        <el-col class="table_td" :span="2">患者</el-col>
                        <el-col class="table_td" :span="2">项目类型</el-col>
                        <el-col class="table_td" :span="2">执行情况</el-col>
                        <el-col class="table_td" :span="3">开单时间</el-col>
                        <el-col class="table_td" :span="1">状态</el-col>
                        <el-col class="table_td" :span="1">医生</el-col>
                        <el-col class="table_td" :span="3">诊断</el-col>
                        <el-col class="table_td" :span="1">金额</el-col>
                        <el-col class="table_td" :span="1">实收</el-col>
                        <el-col class="table_td" :span="2">备注</el-col>
                        <el-col class="table_td" :span="2">操作</el-col>
                    </div>
                </div>
                <div class="tbody_div" :style="{height: `${tableHeight}px`}">
                    <div class="loading_bd flex_c" v-if="tableLoading">
                        <div class="loading_con flex_c">
                            <el-icon class="loading_size is-loading">
                                <Loading />
                            </el-icon>
                            <div class="loading_text">数据加载中</div>
                        </div>
                    </div>
                    <div class="tbody_bd flex_t_col" v-if="tableData.length > 0">
                        <div :class="item.isExpandRow?'tbody_line_div act_bg':'tbody_line_div'" v-for="(item, index) in tableData" :key="index">
                            <div class="tbody_line flex_c_left">
                                <el-col class="table_td flex_c" :span="1">{{ index + 1 }}</el-col>
                                <el-col class="table_td" :span="3">
                                    <el-tag class="mrr5" size="small" :type="item.projectType === '1' ? 'success':'primary'">{{ item.projectType === '0' ? '检查' : '治疗' }}</el-tag>
                                    {{ item.orderNumber }}</el-col>
                                <el-col class="table_td" :span="2">
                                    <div class="base_con">
                                        <span style="font-weight: 600;">{{
                                                item.dppName === null ? '---' : item.dppName
                                            }}</span>
                                            <span style="color:#aaa; margin-left: 15px">{{
                                                    item.dppSex === "0" ? '男' : item.dppSex === "1" ? '女' : '未知'
                                                }} {{ item.dppAge }}岁</span>
                                    </div>
                                </el-col>
                                <el-col class="table_td" :span="2">{{ item.projectName }}</el-col>
                                <el-col class="table_td" :span="2">
                                    <span style="font-size:14px;font-weight: bold;color: #333">{{ item.isExecutedNum }} / {{ item.treatOrderItemList.length }}</span><br/>
                                    <span style="font-size:12px;color: orangered" v-if="item.orderStatus === '1' && item.isExecutedInfo === '0'">未执行，订单待支付</span>
                                    <span style="font-size:12px;color: darkgray" v-if="item.orderStatus === '4' && item.isExecutedInfo === '0'">未执行，订单已取消</span>
                                    <span style="font-size:12px;color: darkorange" v-if="item.orderStatus !== '1' && item.orderStatus !== '4' && item.isExecutedInfo === '0'">订单未开始执行</span>
                                    <span style="font-size:12px;color: blue" v-if="item.orderStatus !== '1' && item.orderStatus !== '4' && item.isExecutedInfo === '1'">订单共{{ item.treatOrderItemList.length }}项，已执行{{ item.isExecutedNum }}项</span>
                                    <span style="font-size:12px;color: green" v-if="item.orderStatus !== '1' && item.orderStatus !== '4' && item.isExecutedInfo === '2'">订单已执行完毕</span>
                                </el-col>
                                <el-col class="table_td" :span="3">{{ item.createTime }}</el-col>
                                <el-col class="table_td" :span="1">
                                    <el-tag class="mrr5" size="small"
                                            :type="item.orderStatus === '1' ? 'danger' : item.orderStatus === '2' ? 'warning' : item.orderStatus === '3' ? 'success' : 'info'">
                                        {{ item.orderStatus === '1' ? '待支付' : item.orderStatus === '2' ? '待执行' : item.orderStatus === '3' ? '已完成' : '已取消' }}</el-tag>
                                </el-col>
                                <el-col class="table_td" :span="1">{{ item.docName }}</el-col>
                                <el-col class="table_td" :span="3">{{ item.diagnosis }}</el-col>
                                <el-col class="table_td font_orange" :span="1">￥{{ item.treatPrice }}</el-col>
                                <el-col class="table_td font_orange" :span="1">￥{{ item.orderPrice }}</el-col>
                                <el-col class="table_td" :span="2">{{ item.remark === null || item.remark === "" || item.remark === undefined ? '无' : item.remark }}</el-col>
                                <el-col class="table_td" :span="2">
                                    <el-button type="primary" size="small" @click="expandRowDetail(item)">详情</el-button>
                                </el-col>
                            </div>
                        </div>
                    </div>
                    <div class="tbody_bd flex_c" v-if="tableData.length <= 0">
                        <el-empty :image-size="100" description="暂无检查治疗工单" />
                    </div>
                </div>
            </div>
            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>



    <!--检查治疗单详情-->
    <el-dialog v-model="treatOrderDetailVisible" center :width="treatOrder.orderStatus === '1'?'40%':'52%'">
        <div class="drawer_detail_body" id="printArea">
            <div class="d_height flex_c">知夏中医门诊部{{ treatOrder.projectType === '0' ? '检查单' : '治疗单' }}</div>
            <div class="drawer_detail_bd">
                <div class="drawer_info_body">
                    <div class="drawer_info_line">
                        <span class="treat_name_font mrr20">{{ treatOrder.dppName }}</span>
                        <span class="mrr20"><span class="font_gray">性别：</span>{{treatOrder.dppSex === '0' ? '男' : treatOrder.dppSex === '1' ? '女' : '未知'}}</span>
                        <span class="mrr20"><span class="font_gray">年龄：</span>{{treatOrder.dppAge === null ? '--' : treatOrder.dppAge}}岁</span>
                        <span class="mrr20"><span class="font_gray">联系电话：</span>{{treatOrder.dppPhone === null ? '无' : treatOrder.dppPhone}}</span>
                    </div>
                    <div class="drawer_info_line">
                        <span class="mrr20"><span class="font_gray">身份证号码：</span>{{treatOrder.dppIdentity===null?"--":treatOrder.dppIdentity.substr(0,6) + '********' + treatOrder.dppIdentity.substr(14, 20)}}</span>
                    </div>
                </div>
            </div>
            <div class="drawer_info_line flex_c_between">
                <div class="width100 flex_c_left">
                    <div class="mrr20"><span class="font_gray">订单编号：</span><span style="font-size:14px;font-weight: bold;color: #333">{{ treatOrder.orderNumber }}</span></div>
                    <div>
                        <span class="font_gray">执行情况：</span>
                        <span style="font-size:14px;font-weight: bold;color: #333">{{ treatOrder.isExecutedNum }} / {{ treatOrder.treatOrderItemList.length }}</span>
                        <span style="font-size:12px;color: orangered" v-if="treatOrder.orderStatus === '1' && treatOrder.isExecutedInfo === '0'">（未执行，订单待支付）</span>
                        <span style="font-size:12px;color: darkgray" v-if="treatOrder.orderStatus === '4' && treatOrder.isExecutedInfo === '0'">（未执行，订单已取消）</span>
                        <span style="font-size:12px;color: darkorange" v-if="treatOrder.orderStatus !== '1' && treatOrder.orderStatus !== '4' && treatOrder.isExecutedInfo === '0'">（订单未开始执行）</span>
                        <span style="font-size:12px;color: blue" v-if="treatOrder.orderStatus !== '1' && treatOrder.orderStatus !== '4' && treatOrder.isExecutedInfo === '1'">（订单共{{ treatOrder.treatOrderItemList.length }}项，已执行{{ treatOrder.isExecutedNum }}项）</span>
                        <span style="font-size:12px;color: green" v-if="treatOrder.orderStatus !== '1' && treatOrder.orderStatus !== '4' && treatOrder.isExecutedInfo === '2'">（订单已执行完毕）</span>
                    </div>
                </div>
                <div class="width30 flex_c_right">
                    <span class="font_gray">订单状态：</span>
                    <span style="font-size:14px;font-weight: bold;"
                          :class="treatOrder.orderStatus === '1' ? 'font_red' : treatOrder.orderStatus === '2' ? 'font_gold' : treatOrder.orderStatus === '3' ? 'font_blue' : 'font_gray'">
                        {{ treatOrder.orderStatus === '1' ? '待支付' : treatOrder.orderStatus === '2' ? '待执行' : treatOrder.orderStatus === '3' ? '已完成' : '已取消' }}</span>
                </div>
            </div>
            <div class="mrt10 thead_div">
                <div class="thead_bd_div border_div child_height child_head_bg flex_c_left">
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:5">项目名称</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">单价</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">金额</el-col>
                    <el-col class="table_td" :span="3" v-if="treatOrder.orderStatus !== '1'">执行状态</el-col>
                    <el-col class="table_td" :span="5" v-if="treatOrder.orderStatus !== '1'">执行时间</el-col>
                    <el-col class="table_td" :span="3" v-if="treatOrder.orderStatus !== '1'">执行人</el-col>
                    <el-col class="table_td" :span="2" v-if="treatOrder.orderStatus !== '1'">操作</el-col>
                </div>
            </div>
            <div class="tbody_div border_div flex_t_col">
                <div class="tbody_line child_height flex_c_left" v-for="(itm, inx) in treatItemData" :key="inx">
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:5">{{ itm.projectName }}</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">￥{{ itm.defaultPrice }}</el-col>
                    <el-col class="table_td" :span="treatOrder.orderStatus === '1'?8:3">￥{{ itm.orderPrice }}</el-col>
                    <el-col class="table_td" :span="4" v-if="treatOrder.orderStatus !== '1'">
                        <el-tag class="mrr5" size="small" :type="itm.excuteStatus === '1' ? 'success':'danger'">{{ itm.excuteStatus === '1' ? '已执行' : '未执行' }}</el-tag>
                    </el-col>
                    <el-col class="table_td" :span="5" v-if="treatOrder.orderStatus !== '1'">{{ itm.excuteTime === null || itm.excuteTime === "" || itm.excuteTime === undefined ? '---' : itm.excuteTime }}</el-col>
                    <el-col class="table_td" :span="4" v-if="treatOrder.orderStatus !== '1'">{{ itm.excuteBy === null || itm.excuteBy === "" || itm.excuteBy === undefined ? '---' : itm.excuteBy }}</el-col>
                </div>
            </div>
            <div class="width100 mrt10 flex_c_between">
                <div class="detail_left">
                    <div class="drawer_info_line" v-if="treatOrder.remark !== null && treatOrder.remark !== '' && treatOrder.remark !== undefined">
                        <span class="font_gray">订单备注：</span>
                        <span style="font-size:14px;">{{ treatOrder.remark === null || treatOrder.remark === "" || treatOrder.remark === undefined ? '无' : treatOrder.remark }}</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">开单医生：</span>
                        <span style="font-size:14px;">{{ treatOrder.docName }}</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">开单时间：</span>
                        <span style="font-size:14px;">{{ treatOrder.createTime }}</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">开单金额：</span>
                        <span style="font-size:14px;color:red;font-weight: bold">{{ treatOrder.treatPrice }} 元</span>
                    </div>
                    <div class="drawer_info_line"> <span class="font_gray">实收金额：</span>
                        <span style="font-size:14px;color:red;font-weight: bold">{{ treatOrder.orderPrice }} 元</span>
                    </div>
                </div>
                <div class="detail_right flex_c_right flex_t_col">
                    <el-image class="detail_right_img"
                              :src="tencentCosUrl + treatOrder.payQrcode"
                              :zoom-rate="1.2"
                              :max-scale="7"
                              :min-scale="0.2" :hide-on-click-modal="true"
                              :preview-src-list="payCodeList"
                              fit="fill"
                    />
                    <span style="font-size:12px;color:#555;margin-top: 5px">扫码线上支付</span>
                </div>
            </div>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button type="success" v-if="treatOrder.orderStatus === '1'" @click="openPayScreen()">收 费</el-button>
                    <el-button type="info" @click="cancelTreatDetail()">关 闭</el-button>
<!--                    <el-button type="warning" v-if="treatOrder.orderStatus === '1'" v-print="printInfoObj">打 印</el-button>-->
                </span>
        </template>

    </el-dialog>

    <!-- 订单收费 -->
    <el-dialog
        v-model="orderPayDialogVisible"
        :before-close="cancalPay"
        :title="treatOrder.projectType === '0' ? '检查单收费' : '治疗单收费'"
        width="32%"
        align-center
    >
        <div class="pay_content flex_c_col">
            <div class="pay_main_body flex_t_col">
                <!--等待扫码-->
                <div class="pay_screen_con flex_c_col" v-if="isWaitPayLoading && !payLoading && !isPayed">
                    <el-icon class="pay_screen_icon">
                        <Connection />
                    </el-icon>
                    <div class="pay_screen_text">正在等待扫码中，请稍候...</div>
                </div>
                <!--加载圈-->
                <div class="pay_loading_con flex_c_col" v-if="isWaitPayLoading && payLoading && !isPayed">
                    <el-icon class="pay_loading_icon is-loading">
                        <loading />
                    </el-icon>
                    <div class="pay_loading_text">正在等待订单支付，请稍候...</div>
                </div>
                <!-- 订单信息-->
                <div class="pay_order_main" v-if="isWaitPayLoading && !isPayed">
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">患者信息：</div>
                        <div class="pay_info_item_right">{{ treatOrder.dppName }} {{treatOrder.dppSex === '0' ? '男' : treatOrder.dppSex === '1' ? '女' : '未知'}} {{treatOrder.dppAge === null ? '--' : treatOrder.dppAge}}岁</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">身份证号：</div>
                        <div class="pay_info_item_right">{{treatOrder.dppIdentity===null?"--":treatOrder.dppIdentity.substr(0,6) + '********' + treatOrder.dppIdentity.substr(14, 20)}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">{{ treatOrder.projectType === '0' ? '检查' : '治疗' }}单号：</div>
                        <div class="pay_info_item_right">{{ treatOrder.orderNumber }}</div>
                    </div>
                    <div class="pay_info_title">支付信息</div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">开单金额：</div>
                        <div class="pay_info_item_right">￥{{ treatOrder.treatPrice }}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">实收金额：</div>
                        <div class="pay_info_item_right font_weight font_orange font_28">￥{{ treatOrder.orderPrice }}</div>
                    </div>
                    <div class="pay_warning_info flex_t_col">
                        <div class="pay_warning_li">*特殊说明：</div>
                        <div class="pay_warning_li">①请仔细核对患者和订单信息，避免错误收费。</div>
                        <div class="pay_warning_li">②请患者打开移动付款码放置扫码盒子上或使用扫码枪扫患者的付款二维码，完成支付。</div>
                    </div>
                </div>
                <!-- 订单结果-->
                <div class="pay_order_main" v-if="!isWaitPayLoading && isPayed">
                    <div class="pay_order_success flex_c_col">
                        <el-icon class="pay_order_success_icon font_green" v-if="payState === 'success'">
                            <SuccessFilled />
                        </el-icon>
                        <el-icon class="pay_order_success_icon font_orange" v-if="payState === 'pending'">
                            <WarningFilled />
                        </el-icon>
                        <el-icon class="pay_order_success_icon font_red" v-if="payState === 'failed'">
                            <CircleCloseFilled />
                        </el-icon>
                        <div class="pay_order_success_text flex_c font_16"><span class="font_gold mrlr10 font_18">{{ patientInfo.name }}</span>
                            的{{ treatOrder.projectType === '0' ? '检查' : '治疗' }}订单{{ payResultText }}</div>
                        <div class="pay_order_error_text flex_c font_14" v-if="payState !== 'success' && payErrorMsg"
                             :style="{color: payState === 'pending' ? '#e6a23c' : '#f56c6c', margin: '8px 0'}">{{ payErrorMsg }}</div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">{{ treatOrder.projectType === '0' ? '检查' : '治疗' }}单号：</div>
                            <div class="pay_info_item_right font_weight">{{ treatOrder.orderNumber }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">支付单号：</div>
                            <div class="pay_info_item_right font_weight">{{ treatOrder.orderNumber }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between" v-if="successPayed">
                            <div class="pay_info_item_left">支付时间：</div>
                            <div class="pay_info_item_right font_weight">{{ treatOrder.payTime }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">开单金额：</div>
                            <div class="pay_info_item_right">￥{{ treatOrder.treatPrice }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">实收金额：</div>
                            <div class="pay_info_item_right font_weight font_orange font_28">￥{{ treatOrder.orderPrice }}</div>
                        </div>
                        <div class="pay_warning_info flex_t_col">
                            <div class="pay_warning_li">*特殊说明：</div>
                            <div class="pay_warning_li" v-if="payState === 'pending'">①支付结果尚未确认，请勿重复扫码，点击「重新查询」确认结果。</div>
                            <div class="pay_warning_li" v-else>①若订单支付失败，请重新扫患者的付款二维码进行扫码支付。</div>
                            <div class="pay_warning_li">②支付完成后，请告知患者可打开“知夏中医健康平台”小程序，查询订单支付结果。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="warning" :loading="querying" v-if="isPayed && payState === 'pending'" @click="requeryPayResult()">重新查询</el-button>
                <el-button type="danger" v-if="isPayed && payState === 'failed'" @click="cancalOrRefreshPay()">刷新重试</el-button>
                <el-button type="success" :loading="receiptLoading" v-if="canPrintSqbReceipt" @click="loadPaymentReceiptAndPrint">打印凭证</el-button>
<!--                <el-button type="primary" v-if="!isPayed" @click="printPayInfo()">打印单据</el-button>-->
                <el-button type="info" @click="cancalPay()">取消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog v-model="receiptPreviewVisible" title="诊疗收款凭证预览" width="440px" align-center>
        <div class="treat-payment-receipt-print receipt-preview-content">
            <div class="treat-receipt-title">{{ displayReceiptValue(paymentReceipt.institutionName) }}</div>
            <div class="treat-receipt-name">诊疗收款凭证</div>
            <div class="treat-receipt-subtitle">TREATMENT PAYMENT RECEIPT</div>
            <div class="treat-receipt-section">
                <div class="treat-receipt-row"><span>患者姓名</span><span>{{ displayReceiptValue(paymentReceipt.patientName) }}</span></div>
                <div class="treat-receipt-row"><span>年龄</span><span>{{ displayReceiptValue(paymentReceipt.patientAge) }}</span></div>
                <div class="treat-receipt-row"><span>性别</span><span>{{ formatReceiptGender(paymentReceipt.patientGender) }}</span></div>
                <div class="treat-receipt-row"><span>诊疗项目</span><span>{{ displayReceiptValue(paymentReceipt.projectName) }}</span></div>
            </div>
            <div class="treat-receipt-amount"><span>实收金额</span><strong>{{ formatReceiptAmount(paymentReceipt.receivedAmount) }}</strong></div>
            <div class="treat-receipt-section">
                <div class="treat-receipt-row"><span>订单号</span><span>{{ displayReceiptValue(paymentReceipt.orderNo) }}</span></div>
                <div class="treat-receipt-row"><span>支付时间</span><span>{{ displayReceiptValue(paymentReceipt.paidAt) }}</span></div>
                <div class="treat-receipt-row"><span>支付方式</span><span>{{ displayReceiptValue(paymentReceipt.paymentMethod) }}</span></div>
            </div>
            <div class="treat-receipt-promotion" v-if="hasReceiptPromotion()">
                <img :src="receiptOfficialAccountQrCode()" @error="handleReceiptPromotionImageError" alt="知夏集团公众号二维码">
                <div>长按识别二维码，关注【知夏集团】公众号</div>
            </div>
            <div class="treat-receipt-footer">请妥善保管本凭条<br><small>本凭条仅作本次付款核对使用</small></div>
        </div>
        <template #footer>
            <el-button @click="receiptPreviewVisible = false">关闭</el-button>
        </template>
    </el-dialog>

    <div id="treatPaymentReceiptPrintArea" class="treat-payment-receipt-print">
        <div class="treat-receipt-title">{{ displayReceiptValue(paymentReceipt.institutionName) }}</div>
        <div class="treat-receipt-name">诊疗收款凭证</div>
        <div class="treat-receipt-subtitle">TREATMENT PAYMENT RECEIPT</div>
        <div class="treat-receipt-section">
            <div class="treat-receipt-row"><span>患者姓名</span><span>{{ displayReceiptValue(paymentReceipt.patientName) }}</span></div>
            <div class="treat-receipt-row"><span>年龄</span><span>{{ displayReceiptValue(paymentReceipt.patientAge) }}</span></div>
            <div class="treat-receipt-row"><span>性别</span><span>{{ formatReceiptGender(paymentReceipt.patientGender) }}</span></div>
            <div class="treat-receipt-row"><span>诊疗项目</span><span>{{ displayReceiptValue(paymentReceipt.projectName) }}</span></div>
        </div>
        <div class="treat-receipt-amount"><span>实收金额</span><strong>{{ formatReceiptAmount(paymentReceipt.receivedAmount) }}</strong></div>
        <div class="treat-receipt-section">
            <div class="treat-receipt-row"><span>订单号</span><span>{{ displayReceiptValue(paymentReceipt.orderNo) }}</span></div>
            <div class="treat-receipt-row"><span>支付时间</span><span>{{ displayReceiptValue(paymentReceipt.paidAt) }}</span></div>
            <div class="treat-receipt-row"><span>支付方式</span><span>{{ displayReceiptValue(paymentReceipt.paymentMethod) }}</span></div>
        </div>
        <div class="treat-receipt-promotion" v-if="hasReceiptPromotion()">
            <img :src="receiptOfficialAccountQrCode()" @error="handleReceiptPromotionImageError" alt="知夏集团公众号二维码">
            <div>长按识别二维码，关注【知夏集团】公众号</div>
        </div>
        <div class="treat-receipt-footer">请妥善保管本凭条<br><small>本凭条仅作本次付款核对使用</small></div>
    </div>
    <el-button ref="treatPaymentReceiptPrintButton" class="receipt-print-trigger" v-print="receiptPrintInfoObj">打印诊疗收款凭证</el-button>
</template>

<script>
import treatorder from "@/assets/scripts/treatorder/index";

export default treatorder;
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>
